import React, { useEffect, useState } from 'react'
import { CustomAutocomplete } from 'src/admin/core/components/Select/CustomAutoComplete'
import { getAppBarState } from 'src/store'
import { Enterprise } from 'src/core/models'
import { useAppTranslation } from 'src/admin/core/hooks'

export type UserEnterpriseProps = {
  onChangeValue?: (value: Enterprise, action: string) => void
  selectDefaultEnterprise?: boolean
}

export const UserEnterpriseSelect: React.FC<UserEnterpriseProps> = ({ onChangeValue, selectDefaultEnterprise = true }) => {
    const { enterprises } = getAppBarState().appState
    const { label } = useAppTranslation()
    const [selectedEnterprise, setSelectedEnterprise] = useState<Enterprise | null>(null)

    useEffect(() => {
      if (enterprises.length === 1) {
        const defaultEnterprise = enterprises[0]
        setSelectedEnterprise(defaultEnterprise)
        onChangeValue?.(defaultEnterprise, 'default')
      }
      else if (selectDefaultEnterprise) {
        const enterprise = window.sessionStorage.getItem('selectedEnterprise')
        if (enterprise) {
          const defaultEnterprise = JSON.parse(enterprise) as Enterprise
          setSelectedEnterprise(defaultEnterprise)
          onChangeValue?.(defaultEnterprise, '')
        }
      }
    }, [enterprises, selectDefaultEnterprise])

  return (
    <CustomAutocomplete
      onChangeValue={(value, action) => {
        setSelectedEnterprise(value)
        if (onChangeValue) onChangeValue(value, action)
      }}
      data={enterprises}
      defaultValue={selectedEnterprise}
      placeholder={label('SELECCIONAR_CONSORCIO')}
      keyLabel={'name'}
      isLoading={false}
      label={label('CONSORCIOS')}
      disabled={enterprises.length === 1}
    />
  )
}
